module.exports = __webpack_public_path__ + "img/product_logo.0f8749ad.png";